import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Field, reduxForm, reset } from 'redux-form';
import { compose } from 'react-apollo';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';

import Loader from '../../Loader';
import messages from '../../../locale/messages';
import { sendEmail } from '../../../core/email/sendEmail';
import showToaster from '../../../helpers/toasterMessages/showToaster';
import { LANDING_CONTACT_INFO_EMAIL } from '../landingContent';

import s from './Contact.css';
import btn from '../shared/landingButtons.css';

class LandingContactForm extends Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    error: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      contactLoading: false,
    };
  }

  handleClick = async (values, dispatch) => {
    this.setState({ contactLoading: true });

    const content = {
      phoneNumber: values.phoneNumber,
      name: values.name,
      email: values.email || 'N/A',
      ContactMessage: values.contactMessage,
    };

    const { status } = await sendEmail(LANDING_CONTACT_INFO_EMAIL, 'contact', content);

    this.setState({ contactLoading: false });

    if (status === 200) {
      showToaster({ messageId: 'emailSent', toasterType: 'success' });
    } else {
      showToaster({ messageId: 'formError', toasterType: 'error' });
    }

    dispatch(reset('LandingContactForm'));
  };

  renderFormControl = ({ input, label, type }) => (
      <div className={s.fieldWrapper}>
        <input
          {...input}
          type={type || 'text'}
          placeholder={label}
          className={s.contactInput}
        />
      </div>
    );

  renderFormControlTextArea = ({ input, label }) => (
      <div className={s.fieldWrapper}>
        <textarea
          {...input}
          placeholder={label}
          className={cx(s.contactInput, s.contactTextarea)}
        />
      </div>
    );

  render() {
    const { error, handleSubmit, submitting } = this.props;
    const { formatMessage } = this.props.intl;
    const { contactLoading } = this.state;

    return (
      <form className={s.contactForm} onSubmit={handleSubmit(this.handleClick)}>
        {error && <span className={s.errorMessage}>{formatMessage(error)}</span>}

        <Field
          name="name"
          type="text"
          component={this.renderFormControl}
          label={formatMessage(messages.newLandingNamePlaceholder)}
        />
        {/* email field (translations in locale messages) */}
        <Field
          name="email"
          type="email"
          component={this.renderFormControl}
          label={formatMessage(messages.newLandingEmailPlaceholder)}
        />
        <Field
          name="phoneNumber"
          type="tel"
          component={this.renderFormControl}
          label={formatMessage(messages.newLandingPhonePlaceholder)}
        />
        <Field
          name="contactMessage"
          component={this.renderFormControlTextArea}
          label={formatMessage(messages.newLandingCommentPlaceholder)}
        />

        <Loader
          type="button"
          buttonType="submit"
          className={cx(btn.landingBtn, btn.landingBtnSubmitBlock)}
          disabled={submitting}
          show={contactLoading}
          label={formatMessage(messages.newLandingSubmitRequest)}
        />
      </form>
    );
  }
}

LandingContactForm = reduxForm({
  form: 'LandingContactForm',
})(LandingContactForm);

export default compose(
  injectIntl,
  withStyles(s, btn),
)(LandingContactForm);
